import { useState, useCallback, useEffect } from 'react'
import { TaskRepositoryModelTypeWithTags } from '../../../app/erp/screens/Company/Tasks/TaskRepositories/types'
import { twinFetchPostJSON } from '../../globals/data'
import { TwinDictionary, dictionaryComplexFromJsonArr } from '../../globals/dictionary'

interface TaskRepositoryTagSelectorProps {
    setData: React.Dispatch<React.SetStateAction<TaskRepositoryModelTypeWithTags | null>>
}

const useTaskRepositoryTags = ({ setData }: TaskRepositoryTagSelectorProps) => {
    const [taskRepositoryTags, setTaskRepositoryTags] = useState<TwinDictionary | null>(null)
    
    const getTaskRepositoryTags = useCallback(async() => {
        const result = await twinFetchPostJSON('/api/app/task/repository/tag/getAllTaskRepositoryTags', {})
        if(result){
            setTaskRepositoryTags(dictionaryComplexFromJsonArr(result))
        }
    }, [setTaskRepositoryTags])
    
    const addTag = useCallback((TagId: number) => {
        setData((old) => {
            if(!old){
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (!copyOld.tags){
                copyOld.tags = []
            }
            copyOld.tags.push(TagId)
            return{...copyOld}
        })
    }, [setData])

    const removeTag = useCallback((posArr: number) => {
        setData((old) => {
            if(!old){
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.tags.splice(posArr, 1)
            return {...copyOld}
        })
    }, [setData])

    useEffect(() => {
        getTaskRepositoryTags()
    }, [getTaskRepositoryTags])

    return { addTag, removeTag, taskRepositoryTags }
}

export default useTaskRepositoryTags